import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { Site } from './types';
import { zodGetSiteEndpointSchema, zodSiteResponseSchema } from './validations';

/**
 * Fetches site data from the API.
 *
 * @param siteId - The ID of the site to fetch.
 * @param options - Optional ky request options including abort signal.
 * @returns The site data if successful.
 * @throws Error if the API request fails.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Site/operation/get_site_site__site_uuid__get
 */
export const fetchSite = async (siteId: UUID, options?: KyRequestOptions) => {
  const response = await vestigasApi
    .get(ENDPOINT.SITE.GET(siteId), {
      validate: {
        pathSegments: zodGetSiteEndpointSchema,
      },
      ...options,
    })
    .json<Site>();

  // Validate the returned data
  const validatedResponse = zodSiteResponseSchema.safeParse(response);

  if (validatedResponse.success) {
    return validatedResponse.data;
  }

  return undefined;
};
